import React from 'react';
import { DetailsAndTTLContainer, TypeAndCategoryWrapper, DetailsContainer, TimeToLiveContainer, TimeToLiveHeader, TimeToLiveActivationContainer, NoLimitButton, ErrorMessage, FieldContainer } from './DetailsAndTTL.styled';
import { Typography,  TextField, Select, RadioButton, TextDescription } from "@ann/web-components"

const DetailsAndTTL = ({ 
  formData, 
  errors = {},
  formState = {},
  onNameChange,
  onNameBlur,
  onDescriptionChange,
  onDescriptionBlur,
  onTypeChange,
  onCategoryChange,
  onTTLValueChange,
  onTTLUnitChange,
  onNoTimeLimitChange
}) => {
  const handleNoLimitClick = () => {
    onNoTimeLimitChange(!formData.isNoTimeLimit);
  };

  return (
    <DetailsAndTTLContainer>
      <DetailsContainer>

        <TimeToLiveHeader>
          <Typography category="subtitle" size="medium" weight="bold">
            Details
          </Typography>
        </TimeToLiveHeader>

        <FieldContainer>
          <TextField
            label="Workflow Name"
            size="small"
            placeholder="No Reply After 48h"
            value={formData.name}
            onChange={onNameChange}
            onBlur={onNameBlur}
            state={formState.name}
          />
          {errors.name && (
            <ErrorMessage>{errors.name}</ErrorMessage>
          )}
        </FieldContainer>

        <TypeAndCategoryWrapper>
          <Select
            label="Type"
            size="small"
            width="50%"
            minWidth="50%"
            value={formData.type}
            onChange={onTypeChange}
          >
            <Select.Menu width="100%" minWidth="100%">
              <Select.Item
                label="Customer"
                value="customer"
              >
                Customer
              </Select.Item>
              <Select.Item
                label="Events"
                value="events"
              >
                Events
              </Select.Item>
              <Select.Item
                label="Finance"
                value="finance"
              >
                Finance
              </Select.Item>
              <Select.Item
                label="Support"
                value="support"
              >
                Support
              </Select.Item>
            </Select.Menu>
          </Select>

          <Select
            label="Category"
            size="small"
            width="50%"
            minWidth="50%"
            value={formData.category}
            onChange={onCategoryChange}
          >
            <Select.Menu width="100%" minWidth="100%">
              <Select.Item
                label="Sales"
                value="sales"
              >
                Sales
              </Select.Item>
              <Select.Item
                label="Marketing"
                value="marketing"
              >
                Marketing
              </Select.Item>
              <Select.Item
                label="General"
                value="general"
              >
                General
              </Select.Item>
              <Select.Item
                label="Technical"
                value="technical"
              >
                Technical
              </Select.Item>
            </Select.Menu>
          </Select>
        </TypeAndCategoryWrapper>

        <FieldContainer>
          <TextDescription
            height="148px"
            label="Description"
            maxCharacters={180}
            onChange={onDescriptionChange}
            onBlur={onDescriptionBlur}
            placeholder={"Retry last message or escalate to advisor via PA (optional)"}
            size="small"
            value={formData.description}
            state={formState.description}
          />
        </FieldContainer>

      </DetailsContainer>

      <TimeToLiveContainer>
        <TimeToLiveHeader>
          <Typography category="subtitle" size="medium" weight="bold">
            Time to Live (TTL)
          </Typography>

          <Typography category="body" size="medium" weight="regular">
            Set how long this trigger stays active for each customer after activation.
          </Typography>
        </TimeToLiveHeader>
        <TimeToLiveActivationContainer>
          <TextField 
            size="small" 
            placeholder="48"
            disabled={formData.isNoTimeLimit}
            readOnly={formData.isNoTimeLimit}
            value={formData.ttlValue}
            onChange={onTTLValueChange}
          />

          <Select
            label=""
            size="small"
            width="auto"
            minWidth="auto"
            disabled={formData.isNoTimeLimit}
            value={formData.ttlUnit}
            onChange={onTTLUnitChange}
          >
            <Select.Menu>
              <Select.Item
                label="Hours"
                value="hours"
              >
                Hours
              </Select.Item>
              <Select.Item
                label="Minutes"
                value="minutes"
              >
                Minutes
              </Select.Item>
              <Select.Item
                label="Seconds"
                value="seconds"
              >
                Seconds
              </Select.Item>
            </Select.Menu>
          </Select>

          <NoLimitButton onClick={handleNoLimitClick}>
            <RadioButton 
              size="small"
              selected={formData.isNoTimeLimit}
            />
            <Typography category="body" size="medium" weight="regular">
              No time limit
            </Typography>
          </NoLimitButton>
        </TimeToLiveActivationContainer>
      </TimeToLiveContainer>
    </DetailsAndTTLContainer>
  );
}

export default DetailsAndTTL;
